import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import MobileZoomInImage from './MobileZoomInImage/MobileZoomInImage';
import DesktopZoomInImage from './DesktopZoomInImage/DesktopZoomInImage';
const ZoomInImage = ({ image, isMobile, isMediaCarousal, heading }) => {
    return (_jsx(_Fragment, { children: isMobile ? (_jsx(MobileZoomInImage, { image: image, isMediaCarousal: isMediaCarousal, heading: heading })) : (_jsx(DesktopZoomInImage, { image: image, isMediaCarousal: isMediaCarousal, heading: heading })) }));
};
export default ZoomInImage;
